import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ContentTimecodesQuery } from "../graphql/queries";
import type {
  ContentTimecodesQueryType,
  ContentTimecodesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useContentTimecodesQuery = (
  options?: QueryHookOptions<
    ContentTimecodesQueryType,
    ContentTimecodesQueryVariablesType
  >
) => {
  return useQuery<
    ContentTimecodesQueryType,
    ContentTimecodesQueryVariablesType
  >(ContentTimecodesQuery, options);
};
